import { Component, OnInit, Input, OnDestroy } from '@angular/core';
@Component({
  selector: 'text-widget',
  templateUrl: './textdisplay.component.html',
  styleUrls: ['./textdisplay.component.scss']
})
export class TextdisplayComponent implements OnInit {
	@Input('color') color: string;
	@Input('text') set text(value: string){
    this._text = value;
    this.setup();
  }
  get text():string{
    return this._text;
  }
  @Input('boxed') boxed: boolean;
	textBefore:string;
	textAfter:string;
	icon:string;
  _hasIcon:boolean=false;
  _text :string = '';
  iconStrings : Array<string> = new Array<string>();
  textStrings : Array<string> = new Array<string>();
    
	constructor() { }
  getFirstIcon(){
    let rv = this.firstIcon + this.iconColor;
    //console.log("rv: "+rv);
    return rv;
  }
  getSecondIcon(){
    return this.secondIcon + this.iconColor;
  }
  
	getTextBeforeIcon(){
		return this.textBefore;
	}
	getTextAfterIcon(){
	  return this.textAfter;
	}
	getIcon(){
		return this.icon;
	}

	hasIcon(){
    return this._hasIcon;
	}

  get iconColor(){
    
    switch(this.color){
      case '#00917E':{
        return 'Green';
      }
      case '#595959':{
        return 'Grey';
      }
      case '#222222':{
        return 'Darkgrey';
      }
      case '#7F7F7F':{

        return 'Lightgrey';
      }
      case 'white':
      default:{
        return '';
      }  
    }
    
  }
	getText(){
    if(this._text){
      return this._text;
    }else{
      return " ";
    }
	}
  iconCount=0;
  beforeFirstIcon="";
  firstIcon="";
  beforeSecondIcon="";
  secondIcon="";
  afterSecondIcon="";
  setup():void{
    let t = this._text;
    this._hasIcon = false;
    this.iconStrings.length=0;
    this.textStrings.length=0;
    let currentText = null;
    let currentIcon = null;

    let obPos = t.indexOf('{{');
    if(obPos == -1){
       this.iconCount = 0;
       this.beforeFirstIcon = t;
       return;
    } 
    let cbPos = t.indexOf('}}');
    if(obPos >= 0){
      this.beforeFirstIcon = t.substring(0,obPos);
      this.firstIcon = t.substring(obPos+2,cbPos);
      this.iconCount = 1;
    }

    t = t.replace(t.substring(0,cbPos+2),'');

    obPos = t.indexOf('{{');
    cbPos = t.indexOf('}}');
    if(obPos == -1){
      this.beforeSecondIcon=t;
      return;
    }else{
      this.beforeSecondIcon= t.substr(0,obPos);
      
    }
    this.secondIcon=t.substring(obPos+2,cbPos);
    this.iconCount = 2;
    t=t.replace(t.substring(0,cbPos+2),'');
    this.afterSecondIcon=t;
  }
  oldSetup(){
    let beginPos = this._text.indexOf('{{');
    if(beginPos == -1){
      this._hasIcon = false;
      return;
    }else{
      let endPos = this._text.indexOf('}}');
      if(endPos == -1){
        this._hasIcon = false;      
        return;
      }
      this.textBefore = this._text.substring(0,beginPos);
      this.textAfter = this._text.substring(endPos+2,this._text.length);
      this.icon=this._text.substring(beginPos+2,endPos);
      this._hasIcon = true;
      return;
    }
  }
	ngOnInit() {
	  this.setup();
	}
	ngOnDestroy(){
	}
}
